(function () {
  function initFuelHeader(section) {
    if (!section || section.dataset.fuelHeaderInit === 'true') return;
    section.dataset.fuelHeaderInit = 'true';

    /* Shared UI controller so search / mega / account stay mutually exclusive. */
    var ui = {
      closeSearch: function () {},
      closeMega: function () {},
      closeAccount: function () {},
      activate: function (layer) {
        if (layer !== 'search') ui.closeSearch();
        if (layer !== 'mega') ui.closeMega();
        if (layer !== 'account') ui.closeAccount();
      }
    };
    section._fuelUI = ui;

    initMegaMenu(section, ui);
    initAccountDropdown(section, ui);
    initFuelSearch(section, ui);
    initMobileDrawer(section);
    initFuelSticky(section);
  }

  function isFuelVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var node = el;
    while (node && node !== document.body) {
      var s = window.getComputedStyle(node);
      if (s.display === 'none' || s.visibility === 'hidden') return false;
      node = node.parentElement;
    }
    return el.getBoundingClientRect().height > 0;
  }

  /* Fuel-only sticky: sticks #header-outer; #nav-top scrolls away. Does not use theme `.fixed`. */
  function initFuelSticky(section) {
    var outer = section.querySelector('#header-outer.fuel-header__outer--sticky');
    if (!outer || outer.dataset.fuelStickyInit === 'true') return;
    outer.dataset.fuelStickyInit = 'true';

    var parent = outer.parentNode;
    if (!parent) return;

    var sentinel = document.createElement('div');
    sentinel.className = 'fuel-header-sticky-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'width:100%;height:1px;margin:0;padding:0;pointer-events:none;';
    parent.insertBefore(sentinel, outer);

    var spacer = document.createElement('div');
    spacer.className = 'fuel-header-sticky-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    if (outer.nextSibling) {
      parent.insertBefore(spacer, outer.nextSibling);
    } else {
      parent.appendChild(spacer);
    }

    var stuck = false;
    document.documentElement.classList.add('has-fuel-sticky');

    function stripThemeFixed() {
      if (section.classList.contains('fixed')) section.classList.remove('fixed');
      var ds = document.getElementById('distance-spacer');
      if (ds) {
        ds.style.setProperty('display', 'none', 'important');
        ds.style.setProperty('height', '0px', 'important');
      }
    }

    function measureBarHeight() {
      var bar = outer.querySelector('#header') || outer.querySelector('.fuel-header__inner') || outer;
      var livesearch = outer.querySelector('#livesearch');
      var lsDisplay = livesearch ? livesearch.style.display : '';
      if (livesearch) livesearch.style.display = 'none';
      var h = bar ? bar.offsetHeight : 0;
      if (livesearch) livesearch.style.display = lsDisplay;
      return h;
    }

    function setStuck(on) {
      if (!isFuelVisible(section)) {
        on = false;
      }
      if (on === stuck) return;
      stuck = on;
      if (on) {
        var h = measureBarHeight();
        spacer.style.height = h + 'px';
        outer.classList.add('is-stuck');
      } else {
        outer.classList.remove('is-stuck');
        spacer.style.height = '0px';
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setStuck(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { root: null, threshold: 0, rootMargin: '0px' }
      );
      observer.observe(sentinel);
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(stripThemeFixed).observe(section, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    stripThemeFixed();

    window.addEventListener('resize', function () {
      if (stuck) spacer.style.height = measureBarHeight() + 'px';
    });

    /* Re-check after A/B / late visibility toggles */
    var tries = 0;
    var poll = setInterval(function () {
      tries += 1;
      if (isFuelVisible(section)) {
        setStuck(sentinel.getBoundingClientRect().top < 0);
      }
      if (tries >= 25) clearInterval(poll);
    }, 400);
  }

  function clearMegaHighlights(scope) {
    var root = scope || document;
    root.querySelectorAll('.fuel-mega__link.is-highlight').forEach(function (link) {
      link.classList.remove('is-highlight');
    });
  }

  function initMegaMenu(section, ui) {
    var navItems = section.querySelectorAll('[data-fuel-mega-trigger]');
    var panels = section.querySelectorAll('[data-fuel-mega-panel]');
    var dropdownItems = section.querySelectorAll('[data-fuel-dropdown]');
    var closeTimer;

    function openPanel(panelId, navItem) {
      if (window.matchMedia('(max-width: 900px)').matches) return;
      if (ui) ui.activate('mega');
      closeAll();
      var panel = section.querySelector('[data-fuel-mega-panel="' + panelId + '"]');
      if (panel) {
        clearMegaHighlights(panel);
        panel.classList.add('is-open');
        if (navItem) {
          navItem.classList.add('is-open');
          var trigger = navItem.querySelector('.fuel-header__nav-link');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
        }
      }
    }

    function openDropdown(navItem) {
      if (window.matchMedia('(max-width: 900px)').matches) return;
      if (ui) ui.activate('mega');
      closeAll();
      if (!navItem) return;
      navItem.classList.add('is-open');
      var trigger = navItem.querySelector('.fuel-header__nav-link');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function closeAll() {
      clearTimeout(closeTimer);
      navItems.forEach(function (item) {
        item.classList.remove('is-open');
        var trigger = item.querySelector('.fuel-header__nav-link');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      dropdownItems.forEach(function (item) {
        item.classList.remove('is-open');
        var trigger = item.querySelector('.fuel-header__nav-link');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.remove('is-open');
      });
      clearMegaHighlights(section);
    }

    if (ui) ui.closeMega = closeAll;

    navItems.forEach(function (item) {
      var panelId = item.getAttribute('data-fuel-mega-trigger');
      var trigger = item.querySelector('.fuel-header__nav-link');

      if (!trigger) return;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openPanel(panelId, item);
      });

      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 120);
      });

      trigger.addEventListener('focus', function () {
        clearTimeout(closeTimer);
        openPanel(panelId, item);
      });
    });

    dropdownItems.forEach(function (item) {
      var trigger = item.querySelector('.fuel-header__nav-link');
      if (!trigger) return;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openDropdown(item);
      });

      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 120);
      });

      trigger.addEventListener('focus', function () {
        clearTimeout(closeTimer);
        openDropdown(item);
      });

      trigger.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 900px)').matches) return;
        /* Keep hover/focus menu; allow link navigation on click */
        clearTimeout(closeTimer);
        openDropdown(item);
      });
    });

    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
      panel.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 120);
      });
    });

    section.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    var links = section.querySelectorAll('.fuel-mega__link');
    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        var siblings = link.closest('.fuel-mega__links');
        if (!siblings) return;
        siblings.querySelectorAll('.fuel-mega__link').forEach(function (l) {
          l.classList.remove('is-highlight');
        });
        link.classList.add('is-highlight');
      });
    });
  }

  /* Chevron-only account dropdown (account icon keeps its own link). */
  function initAccountDropdown(section, ui) {
    var items = section.querySelectorAll('[data-fuel-account]');
    if (!items.length) return;

    function closeItem(item) {
      item.classList.remove('is-open', 'toggle');
      var chevron = item.querySelector('[data-fuel-account-toggle]');
      if (chevron) chevron.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) closeItem(item);
      });
    }

    if (ui) ui.closeAccount = function () { closeAll(); };

    items.forEach(function (item) {
      var chevron = item.querySelector('[data-fuel-account-toggle]');
      if (!chevron) return;

      chevron.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 900px)').matches) return;
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        closeAll();
        if (willOpen) {
          if (ui) ui.activate('account');
          item.classList.add('is-open', 'toggle');
          chevron.setAttribute('aria-expanded', 'true');
        }
      });

      /* Account icon / login link should also dismiss search + mega. */
      var accountLink = item.querySelector('.fuel-account__link');
      if (accountLink) {
        accountLink.addEventListener('click', function () {
          if (ui) ui.activate('account');
        });
        accountLink.addEventListener('focus', function () {
          if (ui) ui.activate('account');
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-fuel-account]')) return;
      closeAll();
    });

    section.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* Theme search JS only binds the first #search (original header). Mirror it for Fuel. */
  function initFuelSearch(section, ui) {
    var form = section.querySelector('[data-fuel-search], #search.fuel-header__search-form, .fuel-header__search-form');
    if (!form) return;

    var input = form.querySelector('input[type="search"]');
    var livesearchEl = form.querySelector('[data-fuel-livesearch], #livesearch');
    if (!input || !livesearchEl) return;

    var htmlTag = document.documentElement;
    var searchTimer;
    var fetchController;

    function loadSearchCss() {
      try {
        if (typeof new_css === 'function' && window.filepaths && window.filepaths.async_search_css) {
          new_css('css-search', window.filepaths.async_search_css);
        }
      } catch (e) {}
    }

    var ignoreOutsideClickUntil = 0;

    function openPanel() {
      loadSearchCss();
      if (ui) ui.activate('search');
      htmlTag.classList.add('search-focus', 'search-full', 'search-full-mode');
      if (window.SearchOverlayV2 && SearchOverlayV2.isEnabled(form)) {
        SearchOverlayV2.applyAbVariant();
        SearchOverlayV2.position(form);
        ignoreOutsideClickUntil = Date.now() + 500;
      }
      form.classList.add('full', 'has-text');
    }

    function closePanel() {
      form.classList.remove('full', 'has-text', 'not-empty', 'processing');
      if (!document.querySelector('#search.has-text, #search.full')) {
        htmlTag.classList.remove('search-full', 'search-full-mode', 'search-focus');
      } else {
        htmlTag.classList.remove('search-focus');
      }
      if (document.activeElement === input) {
        input.blur();
      }
    }

    if (ui) ui.closeSearch = closePanel;

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function buildEmptyStateHtml() {
      var cfg = window.SEARCH_EMPTY;
      if (!cfg) return '';
      if (!(cfg.showSuggestions || cfg.showHistory || cfg.showFeatured || cfg.showCategories)) return '';

      var html = '';
      if (cfg.showSuggestions) {
        var lines = (cfg.suggested || '').split('\n').filter(function (s) { return s.trim().length; });
        if (lines.length) html += '<p class="strong">Suggested results</p><ul class="search-left-list">';
        var baseSearchUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? (window.Shopify.routes.root + 'search')
          : '/search';
        lines.forEach(function (line) {
          var parts = line.split('|');
          var text = (parts[0] || '').trim();
          var raw = (parts[1] || '').trim();
          if (raw.charAt(0) === '@') raw = raw.slice(1).trim();
          var url;
          if (!raw || raw === '#') {
            url = baseSearchUrl + '?q=' + encodeURIComponent(text);
          } else if (raw.indexOf('http://') === 0 || raw.indexOf('https://') === 0 || raw.indexOf('/') === 0) {
            url = raw;
          } else if (raw.charAt(0) === '?') {
            url = baseSearchUrl + raw;
          } else {
            url = baseSearchUrl + '?q=' + encodeURIComponent(raw);
          }
          html += '<li><a href="' + escapeHtml(url) + '">' + escapeHtml(text) + '</a></li>';
        });
        if (lines.length) html += '</ul>';
      }

      if (cfg.showFeatured) {
        var featuredProducts = cfg.featuredProducts || [];
        if (featuredProducts.length > 0) {
          html += '<p class="strong">Featured products</p><ul class="l4ca compact">';
          featuredProducts.forEach(function (p) {
            var price = p.price || '';
            var originalPrice = p.originalPrice || '';
            var img = p.image || '';
            var li = '<li' + (img ? '' : ' class="no-img"') + '>';
            if (img) {
              li += '<figure><picture><img src="' + escapeHtml(img) + '" width="70" height="71" alt="' + escapeHtml(p.title || '') + '"></picture></figure>';
            }
            li += '<section><div class="cols"><h2><a href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title || '') + '</a></h2>';
            if (price) {
              li += '<p class="price s1pr">';
              if (originalPrice && originalPrice !== price) {
                li += '<span class="original-price">' + escapeHtml(originalPrice) + '</span>&nbsp;';
              }
              li += '<span class="wholesale-price">' + escapeHtml(price) + '</span></p>';
            }
            li += '</div></section></li>';
            html += li;
          });
          html += '</ul>';
        }
      }

      if (cfg.showCategories) {
        var cats = Array.isArray(cfg.categories) ? cfg.categories : [];
        if (cats.length > 0) {
          html += '<p class="strong">Featured Brands</p><ul class="search-left-list search-left-list--brands">';
          cats.forEach(function (c) {
            if (!c || !c.title || !c.url) return;
            if (!(c.image && typeof c.image === 'string' && c.image.length > 0)) return;
            html += '<li>';
            html += '<a class="cat-thumb" href="' + escapeHtml(c.url) + '" title="' + escapeHtml(c.title) + '"><figure><picture><img src="' + escapeHtml(c.image) + '" width="70" height="70" alt="' + escapeHtml(c.title) + '"></picture></figure></a>';
            html += '</li>';
          });
          html += '</ul>';
        }
      }

      return html;
    }

    function showEmptyState() {
      if (window.SearchOverlayV2 && SearchOverlayV2.isEnabled(form)) {
        SearchOverlayV2.showEmpty(livesearchEl, form);
        openPanel();
        return;
      }
      var html = buildEmptyStateHtml();
      if (!html) {
        closePanel();
        return;
      }
      livesearchEl.innerHTML = html;
      openPanel();
    }

    function runPredictiveSearch(term) {
      if (!term || !window.routes || !routes.predictive_search_url) return;

      if (window.SearchOverlayV2 && SearchOverlayV2.isEnabled(form)) {
        form.classList.add('processing', 'not-empty');
        openPanel();
        SearchOverlayV2.search(term, livesearchEl, form);
        return;
      }

      if (fetchController) {
        try { fetchController.abort(); } catch (e) {}
      }
      fetchController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      form.classList.add('processing', 'not-empty');
      openPanel();

      var url = routes.predictive_search_url
        + '?q=' + encodeURIComponent(term)
        + '&resources[limit]=12&resources[limit_scope]=each&section_id=livesearch'
        + '&resources[options][fields]=title,product_type,variants.title,variants.sku';

      var predictiveRequest = fetch(url, fetchController ? { signal: fetchController.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        });
      var skuUrl = window.skuLiveSearchUrl && window.skuLiveSearchUrl(term);
      var skuRequest = skuUrl
        ? fetch(skuUrl, fetchController ? { signal: fetchController.signal } : undefined).then(function (response) {
            return response.ok ? response.text() : '';
          }).catch(function () { return ''; })
        : Promise.resolve('');

      Promise.all([predictiveRequest, skuRequest])
        .then(function (parts) {
          var text = parts[0];
          var skuHtml = parts[1] || '';
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var sec = parsed.querySelector('#shopify-section-livesearch');
          livesearchEl.innerHTML = (skuHtml.indexOf('preview-item') !== -1) ? skuHtml : (sec ? sec.innerHTML : '');
          form.classList.remove('processing');
          openPanel();
          bindFuelLiveSearchInteractions(livesearchEl);
          if (typeof attachPreviewCartHandlers === 'function') attachPreviewCartHandlers(livesearchEl);
          try {
            window.dispatchEvent(window.ratingsEvt || new Event('ratings'));
          } catch (e) {}

          livesearchEl.querySelectorAll('[data-search-suggestion]').forEach(function (el) {
            el.addEventListener('click', function (e) {
              var href = el.getAttribute('href');
              if (href && href !== '#' && href !== './') return;
              e.preventDefault();
              e.stopPropagation();
              input.value = el.dataset.searchSuggestion || '';
              form.classList.add('processing');
              runPredictiveSearch(input.value.trim());
            });
          });
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          form.classList.remove('processing');
        });
    }

    function bindFuelLiveSearchInteractions(root) {
      if (!root) return;
      var links = root.querySelectorAll('.search-left-list a[data-preview-src]');
      var pane = root.querySelector('#search-preview-pane');
      if (!pane) return;

      links.forEach(function (anchor) {
        if (anchor.__fuelPreviewBound) return;
        anchor.__fuelPreviewBound = true;

        var runPreview = function () {
          var url = anchor.getAttribute('data-preview-src');
          if (!url) return;
          if (typeof loadPreviewIntoPane === 'function') {
            loadPreviewIntoPane(url, pane);
          }
        };

        anchor.addEventListener('mouseenter', runPreview);
        anchor.addEventListener('focus', runPreview, true);
      });

      if (typeof attachPreviewCartHandlers === 'function') {
        attachPreviewCartHandlers(pane);
      }
    }

    input.addEventListener('focus', function () {
      if (ui) ui.activate('search');
      loadSearchCss();
      htmlTag.classList.add('search-focus');
      if (input.value.trim().length === 0) {
        showEmptyState();
      } else {
        form.classList.add('not-empty');
        openPanel();
        runPredictiveSearch(input.value.trim());
      }
    });

    input.addEventListener('keyup', function () {
      var value = input.value.trim();
      clearTimeout(searchTimer);
      if (value.length === 0) {
        form.classList.remove('not-empty', 'processing');
        showEmptyState();
        return;
      }
      form.classList.add('not-empty');
      openPanel();
      searchTimer = setTimeout(function () {
        runPredictiveSearch(value);
      }, 300);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closePanel();
      }
    });

    document.addEventListener('click', function (e) {
      if (Date.now() < ignoreOutsideClickUntil) return;
      if (
        e.target.closest('.fuel-header__search-form') ||
        e.target.closest('[data-fuel-search]') ||
        e.target.closest('#livesearch')
      ) return;
      if (form.classList.contains('has-text') || form.classList.contains('full') || document.activeElement === input) {
        closePanel();
      }
    });
  }

  function initMobileDrawer(section) {
    var drawer = section.querySelector('[data-fuel-mobile-drawer]');
    var openBtn = section.querySelector('[data-fuel-mobile-open]');
    if (!drawer || !openBtn) return;

    var views = drawer.querySelectorAll('[data-fuel-mobile-view]');

    function showView(name) {
      views.forEach(function (view) {
        var active = view.getAttribute('data-fuel-mobile-view') === name;
        view.classList.toggle('is-active', active);
        if (active) {
          view.removeAttribute('hidden');
        } else {
          view.setAttribute('hidden', '');
        }
      });
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      openBtn.classList.add('is-open');
      document.body.classList.add('fuel-mobile-nav-open');
      showView('root');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.classList.remove('is-open');
      document.body.classList.remove('fuel-mobile-nav-open');
      showView('root');
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    drawer.querySelectorAll('[data-fuel-mobile-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    drawer.querySelectorAll('[data-fuel-mobile-goto]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = el.getAttribute('data-fuel-mobile-goto');
        if (target) showView(target);
      });
    });

    section.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 901px)').matches && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  function boot() {
    document.querySelectorAll('.fuel-header-section').forEach(initFuelHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('fuel-header-section')) {
      event.target.dataset.fuelHeaderInit = '';
      initFuelHeader(event.target);
    }
  });
})();
